/**
 * Lightweight connector for loading dynamic content into the static Web site.
 * Keep it dependency-free so it can be reused across pages and bundles.
 */
(function () {
  const normalizeBase = (value) => String(value || '').replace(/\/+$/, '')

  const defaultApiBase = () => {
    const host = window.location.hostname
    const origin = window.location.origin.replace(/\/+$/, '')

    // Local dev (API default port)
    if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:3000'

    // Local TLS domains (Caddy): api.local.brewskiapp.com etc.
    if (host === 'local.brewskiapp.com' || host.endsWith('.local.brewskiapp.com')) {
      return 'https://api.local.brewskiapp.com'
    }

    // Caddy dev stack exposes API under the same origin at /api (and web at /web).
    if (host.endsWith('.local')) return origin + '/api'

    // Staging: Web at staging.brewskiapp.com, API at api.staging.brewskiapp.com
    if (host === 'staging.brewskiapp.com' || host === 'www.staging.brewskiapp.com') {
      return 'https://api.staging.brewskiapp.com'
    }

    // Production: Web at www.brewskiapp.com, API at api.brewskiapp.com
    if (host === 'brewskiapp.com' || host === 'www.brewskiapp.com') return 'https://api.brewskiapp.com'

    // Safe default.
    return 'https://api.brewskiapp.com'
  }

  const resolveApiBase = () => {
    const override =
      window.__BREWSKI_API_BASE__ ||
      document.documentElement.getAttribute('data-brewski-api-base') ||
      document.body?.getAttribute?.('data-brewski-api-base')

    return normalizeBase(override || defaultApiBase())
  }

  const joinUrl = (base, path) => {
    const trimmedPath = String(path || '').replace(/^\/+/, '')
    return normalizeBase(base) + '/' + trimmedPath
  }

  const getJson = async (path, options) => {
    const apiBase = resolveApiBase()
    const url = joinUrl(apiBase, path)

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      ...(options || {}),
    })

    if (!response.ok) {
      const error = new Error('Request failed')
      error.status = response.status
      error.url = url
      throw error
    }

    return response.json()
  }

  window.BrewskiConnector = {
    resolveApiBase,
    joinUrl,
    getJson,
  }
})()
